export var ESentEmailType = /*#__PURE__*/function (ESentEmailType) {
  ESentEmailType["Registration"] = "registration";
  ESentEmailType["Restore"] = "restore";
  return ESentEmailType;
}({});